import { render, staticRenderFns } from "./TableInternalRequest.vue?vue&type=template&id=2251efed&"
import script from "./TableInternalRequest.vue?vue&type=script&lang=js&"
export * from "./TableInternalRequest.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports